import { useEffect, useState } from 'react';
import './index.scss';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import { StatGetDeviceId } from 'eco-design-micro/EcoStat/config';
import { getGloAIProductList } from 'code-micro/utils/getGloAIProductList';
import generateTraceId from 'eco-design-micro/utils-base/generateTraceId';
import { getWebToken, loginUser } from 'eco-design-micro/utils-user/web/webToken';
import { fetchGetWeb } from 'eco-design-micro/request2/FetchClient';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import getLocal from 'eco-design-reliance/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import useEcoCart from '../../useEcoCart';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import cookie from 'react-cookies';
import * as SERVICE from '../../service';
import { ItfEcoCartAIProduct, ItfEcoCartAIRecommand } from './type';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from '../../type.d';
import { MAX_CART_NUM } from '../../const';
import { i18n } from '../../i18n';

const EcoCartAIRecommand: React.FC<ItfEcoCartAIRecommand> = ({ callback }) => {
    const { locale = '' } = getLocal();
    const t = i18n?.[locale] || i18n.en;
    const { isLogin } = useEcoCart();
    const userId = loginUser()?.user?.userId;
    const [recommendedProducts, setRecommendedProducts] = useState<ItfEcoCartAIProduct[]>([]);
    const { open, items } = useEcoCart();

    const handleAddToCart = (product: ItfEcoCartAIProduct) => {
        const { variantId, productId, price, compareAtPrice, img, variantImg, productTitle, skuTitle, inventoryQuantity, inventoryPolicy } = product;
        try {
            const formattedProduct: ItfEcoCartItem = {
                variantId,
                productId,
                price: Number(price),
                compareAtPrice: Number(compareAtPrice),
                img,
                variantImg,
                productTitle,
                skuTitle,
                quantity: 1,
                inventoryQuantity: inventoryQuantity ?? MAX_CART_NUM,
                inventoryPolicy: inventoryPolicy || 'deny',
            };

            const expires = new Date();
            expires.setDate(expires.getDate() + 7);

            const cookieOptions = {
                path: '/',
                domain: '.ecoflow.com',
                expires,
            };

            cookie.save('display_type', 'AI Brand Cart Recommend_ATC_Recommended for you', cookieOptions);

            // TODO: 埋点
            // gtm.push({
            //     event: 'uaEvent',
            //     event_name: 'bundle_add_to_cart',
            //     list_name: 'AI Cart Recommendation',
            //     product_name: formattedProduct.name,
            //     price: formattedProduct.price,
            //     quantity: 1,
            //     button_name: 'Add',
            //     tag: 'cart_recommendation',
            //     display_type: TextA.recommendTitle,
            //     module_referral: 'AI Brand Cart Recommend',
            //     jump_module: 'none',
            // });

            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [formattedProduct]);

            // 从推荐列表中移除该产品
            setRecommendedProducts((prev) => prev.filter((p) => p.variantId !== product.variantId));
        } catch (error) {
            console.error('添加推荐产品到购物车时发生错误:', error);
        }
    };

    const handleFormatProductList = (productList: any[]) => {
        const formatList: any[] = [];
        productList.forEach((item: any) => {
            formatList.push({
                ...item,
                itemType: 'shopifyProduct',
                variants: [item],
            });
        });

        setRecommendedProducts(formatList?.slice(0, 8));
    };

    const handleQueryProductList = async () => {
        // const res = await queryShopifyProductList(locale);
        const res = await fetchGetWeb(`/shopify/web/shopifyProductVariant/aiRecommend/fallback`, null, {
            locale,
        });
        if (res?.code === '0') {
            const productList = res?.data || [];
            handleFormatProductList(productList);
        } else {
        }
    };

    const handleQueryRecommendList = async (data?: any, currentCartList?: any[]) => {
        try {
            const deviceId = await StatGetDeviceId({});

            const params = {
                triggerPage: 'Brand Cart Recommend',
                tid: generateTraceId(),
                userId,
                deviceId: deviceId || '',
                ...data,
            };
            const productRes = await getGloAIProductList(params, locale);
            if (productRes?.code === '0') {
                let finalList = productRes?.data?.items;
                if (finalList?.length > 0) {
                    if (productRes?.data?.items?.length > 8) {
                        finalList = productRes?.data?.items?.slice(0, 8);
                    }

                    const allProducts: any[] = [];
                    finalList?.forEach((item: any) => {
                        if (item.variants && Array.isArray(item.variants)) {
                            // 将每个 variant 作为独立产品添加到列表中
                            item.variants.forEach((variant: any) => {
                                allProducts.push({
                                    ...variant,
                                    // 保留原有的 item 级别信息（如果需要）
                                    itemId: item.itemId,
                                    itemType: item.itemType,
                                    score: item.score,
                                });
                            });
                        }
                    });

                    // 设置推荐产品并过滤购物车中已有的产品
                    const cartListToFilter = currentCartList || items;
                    const filteredProducts =
                        allProducts?.filter((product: any) => !cartListToFilter?.some((cartItem: any) => cartItem?.variantId === product?.variantId)) || [];
                    setRecommendedProducts(filteredProducts?.slice(0, 8));
                } else {
                    handleQueryProductList();
                }
            } else {
                handleQueryProductList();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleQueryVipData = async (sessionId: string | null, currentCartList?: any[]) => {
        if (!!isLogin) {
            const res = await SERVICE.API_GET_USER_INFO(getWebToken(), locale);
            await handleQueryRecommendList({ ...res, sessionId }, currentCartList);
        } else {
            await handleQueryRecommendList({ sessionId }, currentCartList);
        }
    };

    useEffect(() => {
        if (!!open) {
            if (typeof window !== 'undefined') {
                const session: string | null = sessionStorage.getItem('ef_search_ai_session_id');
                handleQueryVipData(session);
            }
        }
    }, [open]);

    useEffect(() => {
        let h: number = 0;
        if (typeof window !== 'undefined' && recommendedProducts?.length > 0) {
            const el: HTMLDivElement | null = document.querySelector('.eco-cart-ai-recommendation');
            if (el) {
                h = el.offsetHeight || 0;
            }
        }
        callback(h);
    }, [recommendedProducts]);

    return (
        <>
            {recommendedProducts?.length > 0 && (
                <div className={`eco-cart-ai-recommendation`}>
                    <h3 className={`eco-cart-ai-recommendation-title`}>{t.cart_ai_title}</h3>
                    <div className={`eco-cart-ai-recommendation-swiper`}>
                        <Swiper
                            modules={[Navigation, Pagination]}
                            slidesPerView="auto"
                            navigation={false}
                            pagination={{
                                clickable: true,
                            }}
                            className={`eco-cart-ai-swiper`}
                        >
                            {recommendedProducts.map((product: ItfEcoCartAIProduct) => (
                                <SwiperSlide key={product.variantId} className={`eco-cart-ai-recommendation-item`}>
                                    <div className={`eco-cart-ai-recommendation-card`}>
                                        <div className={`eco-cart-ai-recommendation-img`}>
                                            <EcoImg pc={product?.variantImg || product?.img} alt={product?.productTitle || product?.skuTitle} />
                                        </div>
                                        <div className={`eco-cart-ai-recommendation-content`}>
                                            <h4 className={`eco-cart-ai-recommendation-name`} title={product?.productTitle || product?.skuTitle}>
                                                {product?.productTitle || product?.skuTitle}
                                            </h4>
                                            <div className={`eco-cart-ai-recommendation-price`}>
                                                <span className={`eco-cart-ai-recommendation-current-price`}>
                                                    {FormatMoneyLocal(Number(product?.price), locale)}
                                                </span>
                                                {product?.compareAtPrice && product?.price && Number(product?.compareAtPrice) > Number(product?.price) && (
                                                    <span className={`eco-cart-ai-recommendation-original-price`}>
                                                        {FormatMoneyLocal(Number(product?.compareAtPrice), locale)}
                                                    </span>
                                                )}
                                            </div>
                                            <button className={`eco-cart-ai-recommendation-add-btn`} onClick={() => handleAddToCart(product)}>
                                                {t.cart_ai_add}
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            )}
        </>
    );
};

export default EcoCartAIRecommand;
